import { Network } from '@root/entities/network'

import BONKFUN_LOGO from '../assets/bonkfun.inline.png'
import DELUGE_LOGO from '../assets/deluge.inline.svg'
import JUPITER_LOGO from '../assets/jupiter.inline.svg'
import METEORA_LOGO from '../assets/meteora.inline.svg'
import ORCA_LOGO from '../assets/orca.inline.svg'
import PANCAKESWAP_LOGO from '../assets/pancakeswap.inline.svg'
import PUMPFUN_MAYHEM_LOGO from '../assets/pumpfun-mayhem.inline.svg'
import PUMPFUN_LOGO from '../assets/pumpfun.inline.svg'
import PUMPSWAP_LOGO from '../assets/pumpswap.inline.svg'
import RAYDIUM_LOGO from '../assets/raydium.inline.svg'
import UNISWAP_LOGO from '../assets/uniswap.inline.svg'

import type { TradeApi } from '@root/shared/api'

export type Id = TradeApi.ProviderId

type ProviderBase = {
  // Identifier used in BE
  id: Id
  internalId: string
  title: string
  logoUrl: string
}

export const orcaWp = {
  id: 'orca',
  internalId: 'orca' as const,
  logoUrl: ORCA_LOGO,
  title: 'Orca WP',
} satisfies ProviderBase

export const jupiter = {
  id: 'jupiter',
  internalId: 'jupiter' as const,
  logoUrl: JUPITER_LOGO,
  title: 'Jupiter',
} satisfies ProviderBase

export const meteoraDyn = {
  id: 'meteora-dyn',
  internalId: 'meteora-dyn' as const,
  logoUrl: METEORA_LOGO,
  title: 'Meteora AMM',
} satisfies ProviderBase

export const meteoraDlmm = {
  id: 'meteora-dlmm',
  internalId: 'meteora-dlmm' as const,
  logoUrl: METEORA_LOGO,
  title: 'Meteora DLMM',
} satisfies ProviderBase

export const raydiumV4 = {
  id: 'raydium-v4',
  internalId: 'raydium-v4' as const,
  logoUrl: RAYDIUM_LOGO,
  title: 'Raydium V4',
} satisfies ProviderBase

export const raydiumCpmm = {
  id: 'raydium-cpmm',
  internalId: 'raydium-cpmm' as const,
  logoUrl: RAYDIUM_LOGO,
  title: 'Raydium CPMM',
} satisfies ProviderBase

export const raydiumClmm = {
  id: 'raydium-clmm',
  internalId: 'raydium-clmm' as const,
  logoUrl: RAYDIUM_LOGO,
  title: 'Raydium CLMM',
} satisfies ProviderBase

export const raydiumLaunchpad = {
  id: 'raydium-launchpad',
  internalId: 'raydium-launchpad' as const,
  logoUrl: RAYDIUM_LOGO,
  title: 'Raydium Launchpad',
} satisfies ProviderBase

export const bonkFun = {
  id: 'bonk-fun',
  internalId: 'bonk-fun' as const,
  logoUrl: BONKFUN_LOGO,
  title: 'Bonk Fun',
} satisfies ProviderBase

export const uniswapV2 = {
  id: 'uniswap-v2',
  internalId: 'uniswap-v2' as const,
  logoUrl: UNISWAP_LOGO,
  title: 'Uniswap V2',
} satisfies ProviderBase

export const uniswapV3 = {
  id: 'uniswap-v3',
  internalId: 'uniswap-v3' as const,
  logoUrl: UNISWAP_LOGO,
  title: 'Uniswap V3',
} satisfies ProviderBase

// #region Not used
export const dedust = {
  id: 'dedust',
  internalId: 'dedust' as const,
  logoUrl: UNISWAP_LOGO,
  title: 'Dedust',
} satisfies ProviderBase

export const stonfiV1 = {
  id: 'stonfi-v1',
  internalId: 'stonfi-v1' as const,
  logoUrl: UNISWAP_LOGO,
  title: 'Stonfi V1',
} satisfies ProviderBase

export const stonfiV2 = {
  id: 'stonfi-v2',
  internalId: 'stonfi-v2' as const,
  logoUrl: UNISWAP_LOGO,
  title: 'Stonfi V2',
} satisfies ProviderBase

// #endregion

export const pumpFun = {
  id: 'pump-fun',
  internalId: 'pump-fun' as const,
  logoUrl: PUMPFUN_LOGO,
  title: 'Pump Fun',
} satisfies ProviderBase

export const pumpFunMayhem = {
  id: 'pump-fun',
  internalId: 'pump-fun-mayhem' as const,
  logoUrl: PUMPFUN_MAYHEM_LOGO,
  title: 'Mayhem',
} satisfies ProviderBase

export const pumpSwap = {
  id: 'pump-swap',
  internalId: 'pump-swap' as const,
  logoUrl: PUMPSWAP_LOGO,
  title: 'Pump Swap',
} satisfies ProviderBase

export const delugeVlmm = {
  id: 'deluge-vlmm',
  internalId: 'deluge-vlmm' as const,
  logoUrl: DELUGE_LOGO,
  title: 'Deluge VLMM',
} satisfies ProviderBase

export const pancakeswapV1 = {
  id: 'pancakeswap-v1',
  internalId: 'pancakeswap-v1' as const,
  logoUrl: PANCAKESWAP_LOGO,
  title: 'Pancakeswap V1',
} satisfies ProviderBase

export const pancakeswapV2 = {
  id: 'pancakeswap-v2',
  internalId: 'pancakeswap-v2' as const,
  logoUrl: PANCAKESWAP_LOGO,
  title: 'Pancakeswap V2',
} satisfies ProviderBase

export const pancakeswapV3 = {
  id: 'pancakeswap-v3',
  internalId: 'pancakeswap-v3' as const,
  logoUrl: PANCAKESWAP_LOGO,
  title: 'Pancakeswap V3',
} satisfies ProviderBase

export type Provider =
  | typeof orcaWp
  | typeof jupiter
  | typeof meteoraDyn
  | typeof meteoraDlmm
  | typeof raydiumV4
  | typeof raydiumCpmm
  | typeof raydiumClmm
  | typeof raydiumLaunchpad
  | typeof bonkFun
  | typeof uniswapV2
  | typeof uniswapV3
  | typeof dedust
  | typeof pumpFun
  | typeof pumpFunMayhem
  | typeof pumpSwap
  | typeof stonfiV1
  | typeof stonfiV2
  | typeof delugeVlmm
  | typeof pancakeswapV1
  | typeof pancakeswapV2
  | typeof pancakeswapV3

export type InternalId = Provider['internalId']

export const byId: Record<Id, Provider> = {
  ['orca']: orcaWp,
  ['jupiter']: jupiter,
  ['meteora-dyn']: meteoraDyn,
  ['meteora-dlmm']: meteoraDlmm,
  ['raydium-v4']: raydiumV4,
  ['raydium-cpmm']: raydiumCpmm,
  ['raydium-clmm']: raydiumClmm,
  ['raydium-launchpad']: raydiumLaunchpad,
  ['bonk-fun']: bonkFun,
  ['uniswap-v2']: uniswapV2,
  ['uniswap-v3']: uniswapV3,
  ['dedust']: dedust,
  ['pump-fun']: pumpFun,
  ['pump-swap']: pumpSwap,
  ['stonfi-v1']: stonfiV1,
  ['stonfi-v2']: stonfiV2,
  ['deluge-vlmm']: delugeVlmm,
  ['pancakeswap-v1']: pancakeswapV1,
  ['pancakeswap-v2']: pancakeswapV2,
  ['pancakeswap-v3']: pancakeswapV3,
}

export const fromDto = (
  id: Id,
  extra:
    | {
        isPumpFunMayhem: boolean
      }
    | undefined,
) => {
  const provider = byId[id]!
  if (provider === pumpFun && extra?.isPumpFunMayhem) {
    return pumpFunMayhem
  }

  return provider
}

export const providersByNetwork: Record<Network.Network, Array<Provider>> = {
  [Network.Ethereum]: [uniswapV2, uniswapV3],
  [Network.Base]: [uniswapV2, uniswapV3],
  [Network.Solana]: [
    // orcaWp,
    pumpFun,
    pumpSwap,
    // jupiter,
    // meteoraDyn,
    // meteoraDlmm,
    raydiumV4,
    raydiumCpmm,
    // raydiumClmm,
    raydiumLaunchpad,
    bonkFun,
  ],
  [Network.Ton]: [stonfiV1, stonfiV2],
  [Network.Bsc]: [],
}
